// TermsConditions.js
import React from "react";
import "../../../assets/css/customer/components/TermsCondition.css";
import "../../../assets/css/customer/subscreens/account/PrivacySettings.css";
import { AiOutlineClose } from "react-icons/ai";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import MyNavbar from "../../general/mynavbar/MyNavbar";

// ============================================================
// 1) TERMS MODAL - Signup page ke liye (BILKUL WAISA HI, NO CHANGE)
// ============================================================
const TermsModal = ({ show, onClose }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="terms-modal-overlay" onClick={onClose}>
      <div className="terms-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="terms-modal-header">
          <h3 className="terms-modal-title">Customer Terms & Conditions</h3>
          <button
            type="button"
            className="terms-modal-close"
            onClick={onClose}
          >
            <AiOutlineClose size={16} />
          </button>
        </div>

        <div className="terms-modal-body">
          <div className="terms-modal-point">
            <span className="terms-modal-number">1</span>
            <p className="terms-modal-text">
              <span className="terms-modal-heading">Account Information</span>
              Customers are responsible for providing correct and complete
              information when creating an account and placing orders.
            </p>
          </div>

          <div className="terms-modal-point">
            <span className="terms-modal-number">2</span>
            <p className="terms-modal-text">
              <span className="terms-modal-heading">Placing an Order</span>
              Please review the product details, quantity, customization
              requirements, and delivery address carefully before confirming
              your order.
            </p>
          </div>

          <div className="terms-modal-point">
            <span className="terms-modal-number">3</span>
            <p className="terms-modal-text">
              <span className="terms-modal-heading">Product Information</span>
              Product images and descriptions are provided to help customers
              make informed decisions. Customers should carefully review the
              available details before placing an order.
            </p>
          </div>

          <div className="terms-modal-point">
            <span className="terms-modal-number">4</span>
            <p className="terms-modal-text">
              <span className="terms-modal-heading">Customization</span>
              For customized products, customers should discuss their
              requirements with the seller through CraftHive chat before
              confirming the customization.
            </p>
          </div>

          <div className="terms-modal-point">
            <span className="terms-modal-number">5</span>
            <p className="terms-modal-text">
              <span className="terms-modal-heading">Cash on Delivery</span>
              CraftHive offers Cash on Delivery (COD). Customers are required
              to pay the complete order amount, including the applicable
              delivery charges, upon receiving the order.
            </p>
          </div>

          <div className="terms-modal-point">
            <span className="terms-modal-number">6</span>
            <p className="terms-modal-text">
              <span className="terms-modal-heading">Delivery</span>
              A fixed delivery charge of Rs. 200 per order applies. Customers
              should provide a complete and accurate delivery address.
              Delivery time may vary depending on the seller and location.
            </p>
          </div>

          <div className="terms-modal-point">
            <span className="terms-modal-number">7</span>
            <p className="terms-modal-text">
              <span className="terms-modal-heading">Cancellation</span>
              Orders may be cancelled before dispatch. Once an order has been
              dispatched, it cannot be cancelled.
            </p>
          </div>

          <div className="terms-modal-point">
            <span className="terms-modal-number">8</span>
            <p className="terms-modal-text">
              <span className="terms-modal-heading">Return Policy</span>
              Customers can request a return within 24 hours of receiving the
              order. Return requests made after 24 hours will not be
              accepted.
            </p>
          </div>

          <div className="terms-modal-point terms-modal-point-last">
            <span className="terms-modal-number">9</span>
            <p className="terms-modal-text">
              <span className="terms-modal-heading">Fair Use & Reviews</span>
              Customers must not place fake orders, misuse the platform, or
              provide false information. Reviews and ratings should be honest
              and based on the customer's actual experience.
            </p>
          </div>
        </div>

        <div className="terms-modal-footer">
          <button
            type="button"
            className="terms-modal-close-button"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

// ============================================================
// 2) TERMS CONDITIONS PAGE - Settings ke liye (Privacy Policy jaisa full page)
// ============================================================
export const TermsConditionsPage = () => {
   console.log("TERMS PAGE IS RENDERING"); 
  const navigate = useNavigate();
  

  const sections = [
    {
      title: '1. Account Information',
      content: [
        'Customers are responsible for providing correct and complete information when creating an account and placing orders.'
      ]
    },
    {
      title: '2. Placing an Order',
      content: [
        'Please review the product details, quantity, customization requirements, and delivery address carefully before confirming your order.'
      ]
    },
    {
      title: '3. Product Information',
      content: [
        'Product images and descriptions are provided to help customers make informed decisions. Customers should carefully review the available details before placing an order.'
      ]
    },
    {
      title: '4. Customization',
      content: [
        'For customized products, customers should discuss their requirements with the seller through CraftHive chat before confirming the customization.'
      ]
    },
    {
      title: '5. Cash on Delivery',
      content: [
        'CraftHive offers Cash on Delivery (COD). Customers are required to pay the complete order amount, including the applicable delivery charges, upon receiving the order.'
      ]
    },
    {
      title: '6. Delivery',
      content: [
        'A fixed delivery charge of Rs. 200 per order applies. Customers should provide a complete and accurate delivery address. Delivery time may vary depending on the seller and location.'
      ]
    },
    {
      title: '7. Cancellation',
      content: [
        'Orders may be cancelled before dispatch. Once an order has been dispatched, it cannot be cancelled.'
      ]
    },
    {
      title: '8. Return Policy',
      content: [
        'Customers can request a return within 24 hours of receiving the order. Return requests made after 24 hours will not be accepted.'
      ]
    },
    {
      title: '9. Fair Use & Reviews',
      content: [
        "Customers must not place fake orders, misuse the platform, or provide false information. Reviews and ratings should be honest and based on the customer's actual experience."
      ]
    }
  ];

  return (
    <>
      <MyNavbar />
      <div className="privacy-policy-page">
        <Container>
          <div className="policy-shell-container">
            {/* Header */}
            <div className="policy-header">
              <button className="back-btn" onClick={() => navigate(-1)}>
                <FaArrowLeft size={20} />
              </button>
              <h1>Terms & Conditions</h1>
              <div></div>
            </div>

            {/* Introduction */}
            <div className="policy-intro">
              <p>
                Welcome to CraftHive. These Terms & Conditions explain the
                rules customers agree to follow when creating an account,
                placing orders, and using our platform.
              </p>
            </div>

            {/* Policy Sections */}
            <div className="policy-sections">
              {sections.map((section, index) => (
                <div key={index} className="policy-section">
                  <h3>{section.title}</h3>
                  {section.content.map((paragraph, idx) => (
                    <p key={idx}>{paragraph}</p>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

// Default export = TermsModal (jo pehle se signup pe use ho raha hai, isay chherna nahi)
export default TermsModal;